import React from 'react';
import { cn } from '../../utils';
import {
  Breadcrumb,
  BreadcrumbItem as ShadBreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/shadcn';

export interface BreadcrumbItem {
  label: string;
  path: string;
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  onNavigate?: (path: string) => void;
  className?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, onNavigate, className }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Breadcrumb className={cn(className)}>
      <BreadcrumbList>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <React.Fragment key={item.path}>
              {index > 0 && <BreadcrumbSeparator />}
              <ShadBreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage className="max-w-[10rem] truncate font-medium sm:max-w-[14rem] md:max-w-none">
                    {item.label}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <button
                      type="button"
                      onClick={() => onNavigate?.(item.path)}
                      className="max-w-[8rem] truncate sm:max-w-[12rem] md:max-w-none"
                    >
                      {item.label}
                    </button>
                  </BreadcrumbLink>
                )}
              </ShadBreadcrumbItem>
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default Breadcrumbs;
